export const IconArrowDropUp = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconArrowDropUp_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconArrowDropUp_svg__a)">
        <path d="M7.581 14.465a.55.55 0 0 1-.421-.174.58.58 0 0 1-.16-.407q0-.059.174-.407l4.216-4.215a.9.9 0 0 1 .29-.204A.9.9 0 0 1 12 9q.174 0 .32.058a.9.9 0 0 1 .29.204l4.216 4.215a.547.547 0 0 1 .174.407q0 .232-.16.407a.55.55 0 0 1-.421.174z" />
      </g>
    </svg>
  );
};
